import script from "./AdminDepartements.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDepartements.vue?vue&type=script&setup=true&lang=js"

import "./AdminDepartements.vue?vue&type=style&index=0&id=aabbd848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aabbd848"]])

export default __exports__